module.exports = __webpack_public_path__ + "static/media/Win.aa9ad824.png";